import React from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

interface BulkOpsHeaderProps {
	title: string;
	subtitle?: string;
	/** Omit on the category list — there is nowhere to go back to. */
	backTo?: string;
	backLabel?: string;
	/** Right-aligned controls that belong to the screen as a whole, e.g. an export button. */
	actions?: React.ReactNode;
}

const BulkOpsHeader = ({
	title,
	subtitle,
	backTo,
	backLabel,
	actions,
}: BulkOpsHeaderProps) => {
	const navigate = useNavigate();

	return (
		<div className="flex flex-col gap-2">
			{backTo && (
				<div>
					<Button
						type="text"
						size="small"
						className="px-0"
						icon={<ArrowLeftOutlined />}
						onClick={() => navigate(backTo)}
					>
						{backLabel}
					</Button>
				</div>
			)}
			<div className="flex flex-wrap items-start justify-between gap-3">
				<div>
					<h1 className="text-2xl font-semibold">{title}</h1>
					{subtitle && <p className="text-gray-500">{subtitle}</p>}
				</div>
				{actions && (
					<div className="flex items-center gap-2">{actions}</div>
				)}
			</div>
		</div>
	);
};

export default BulkOpsHeader;
